module.exports = __webpack_public_path__ + "img/2.9be2b79f.png";